import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`

`;
